import React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { NumberInputSpinner } from "../NumberInputSpinner";
import { borderColor } from "main/javascripts/styles/base/colorStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { GuestPickerInputChild } from "./GuestPickerInputChild";
import { MAX_ADULTS } from "../../../constants/CruiseConstants";
import { FormNamespaces } from "../../../constants/FormConstants";

interface IProps {
  namespace: string;
  groupName?: string;
  index: number;
  onUpdate?(index: number, name: string, number: number): void;
}

export const GuestPickerInputRoom: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { namespace, groupName, index } = props;
  const maxAdults = MAX_ADULTS;

  const { t } = useTranslation(["label", "component"]);

  const adultsFieldName = groupName
    ? `${groupName}.number_of_adult`
    : "number_of_adult";

  // const onValueUpdate = (name: string, number: number) => {
  //   if (onUpdate) {
  //     onUpdate(index, name, number);
  //   }
  // };

  const roomIndexTextKey =
    namespace === FormNamespaces.cruise
      ? "component:cruise.cabinIndex"
      : "component:hotel.roomIndex";

  return (
    <div css={roomGroupBlockStyle}>
      <div css={roomGroupTitleStyle}>
        <span>{t(roomIndexTextKey, { index: index + 1 })}</span>
      </div>
      <ul css={listBlockStyle}>
        <li css={listStyle}>
          <div css={listInnerStyle}>
            <div css={textStyle}>{t("common.numberOfAdults")}</div>
            <NumberInputSpinner
              name={adultsFieldName}
              min={1}
              max={maxAdults}
              // onUpdate={onValueUpdate}
            />
          </div>
        </li>
        <li css={listStyle}>
          <GuestPickerInputChild
            namespace={namespace}
            groupName={groupName}
            // onUpdate={onValueUpdate}
            max={maxAdults}
          />
        </li>
      </ul>
    </div>
  );
};

const listBlockStyle = css`
  list-style: none;
  margin: 0;
  padding: ${space.atom};
`;
const listStyle = css`
  border-bottom: 1px solid ${borderColor.primaryLightColor};
  &:last-of-type {
    border-bottom: 0;
  }
`;
const listInnerStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${space.atom1_5x} ${space.atom0_5x} ${space.atom1_5x} ${space.atom};
  font-weight: ${fontWeight.bold};
`;
const textStyle = css`
  font-size: ${fontSize.body};
  line-height: ${lineHeight.body2};
  padding-right: ${space.atom2x};
`;
const roomGroupBlockStyle = css`
  &:before {
    content: "";
    display: block;
    background-color: ${borderColor.secondaryLightColor};
    height: 1px;
    width: calc(100% - ${space.atom3x});
    margin-left: ${space.atom1_5x};
  }
`;
const roomGroupTitleStyle = css`
  display: flex;
  padding: 0 ${space.atom1_5x} 0;
  margin-top: -1px;
  margin-bottom: -${space.atom};
  line-height: ${lineHeight.caption3};
  span {
    display: inline-block;
    background-color: #888;
    font-size: ${fontSize.smallest};
    padding: 0.125rem ${space.atom};
    color: #fff;
  }
`;
